import { FC, ReactNode } from 'react';

import 'components/Table/TableCell/TableCell.less';

export enum TableCellKind {
    Basic = 'basic',
    Title = 'title',
    Date = 'date',
    Amount = 'amount',
}

interface TableCellProps {
    children?: ReactNode;
    kind?: TableCellKind;
    className?: string;
    dataQa?: string;
    align?: 'left' | 'center' | 'right' | 'justify' | 'char' | undefined;
    rowSpan?: number;
    colSpan?: number;
}

const TableCell: FC<TableCellProps> = ({ children, kind, dataQa, ...props }) => (
    <td className={kind ? `table-cell table-cell_${kind}` : ''} data-qa={dataQa} {...props}>
        {children}
    </td>
);

TableCell.defaultProps = {
    kind: TableCellKind.Basic,
};

export default TableCell;
